<template>
	<div>
		<lottie class="lottie" :options="defaultOptions" :height=200 :width=200 v-on:animCreated="handleAnimation" />
	</div>
</template>

<script>
import lottie from "vue-lottie";
import * as animationData from "../../../static/lotties/error.json";

export default {
	name: "lottie_error",
	components: {
		"lottie": lottie,
	},
	data() {
		return {
			defaultOptions: {animationData: animationData.default},
			animationSpeed: 1,
		};
	},
	methods: {
		handleAnimation: function (anim) {
			this.anim = anim;
			this.anim.play();
		},
	},
};
</script>

<style scoped>

</style>
